<!-- BR#162 Sunny 17/03/2026 Implementing Google Authenticator -->
<template>
  <div v-if="visible" class="otp-modal">
    <div class="otp-container">
      <button class="close-btn" @click="closeModal">
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="24" height="24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
  </svg>
</button>
      
      <h2>{{$t("two-factor-authentication")}}</h2>
      <p>{{$t("enter-the-code-from-google-authenticator")}}</p>
      <input
        v-model="otp"
        type="text"
        :placeholder="$t('code')"
        maxlength="6"
        @input="filterNumeric"
        @keyup.enter="verifyOtp"
      />
      <button class="verify-btn" @click="verifyOtp">{{$t("verify")}}</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";

export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      otp: "",
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.clearOtp();
      }
    },
  },
  methods: {
    clearOtp() {
      this.otp = "";
    },
    filterNumeric(event) {
      this.otp = event.target.value.replace(/\D/g, "");
    },
    async verifyOtp() {
      if (this.otp.length !== 6) {
        this.$notify({
          group: "foo",
          text: `${this.$t("please-enter-a-valid-6-digit-otp")}`,
          type: "warn",
          duration: 5000
        });
        this.clearOtp();
        return;
      }

      const otpToken = localStorage.getItem("otp_token");
      const user_id = localStorage.getItem("user_id");

      if (!otpToken || !user_id) {
        this.$notify({
          group: "foo",
          text: `${this.$t("session-expired-please-try-again")}`,
          type: "error",
          duration: 5000
        });
        return;
      }

      const requestData = {
        otp: this.otp,
        otp_token: otpToken,
        user_id: user_id,
        tfa_enabled: true
      };
      const url = `${process.env.VUE_APP_API_URL}accounts/verify_authenticator_otp/`;

      try {
        const response = await axios.post(url, requestData);
        const token = response.data.token;
        const currentUrl = window.location.href;

        Cookies.set("auth_token", token, { expires: 7, secure: true });

        this.$emit("otpVerified", { otp: this.otp });
       if (currentUrl.includes("withdraw-funds")) {
        this.$notify({
          group: "foo",
          text: `${this.$t("otp-verified-successfully")}`,
          type: "success",
          duration: 2000
        });
      } else {
        this.$notify({
          group: "foo",
          text: `${this.$t("otp-verified-successfully")}`,
          type: "success",
          duration: 5000
        });
      }
      } catch (error) {
        const err_msg = error?.response?.data?.error
        const translatedError = this.sanitizeText(err_msg);
        this.$notify({
          group: "foo",
          text: translatedError,
          type: "warn",
          duration: 5000,
        });
        this.clearOtp();
      }
    },
    async resendOtp() {
      const user_id = localStorage.getItem("user_id");
      const currentUrl = window.location.href;

      if (!user_id) {
        this.$notify({
          group: "foo",
          text: `${this.$t("user-id-not-found-please-try-again")}`,
          type: "error",
          duration: 5000
        });
        return;
      }
      let endpoint = "accounts/otp_regeneration/";
      if (currentUrl.includes("withdraw-funds")) {
        endpoint = "accounts/withdrawal_otp_regeneration/";
      }

      const url = `${process.env.VUE_APP_API_URL}${endpoint}`;
      const payload = {
        user_id,
        language: this._i18n.i18next.language
      };
      console.log("payload is = ", payload)
      try {
        const response = await axios.post(url, payload);

        this.$notify({
          group: "foo",
          text: `${this.$t("otp-resent-successfully")}`,
          type: "success",
          duration: 5000
        });
      } catch (error) {
        const err_msg = error?.response?.data?.error
        const translatedError = this.sanitizeText(err_msg || this.$t("failed-to-resend-otp-please-try-again"))
        this.$notify({
          group: "foo",
          text: translatedError,
          type: "error",
          duration: 5000,
        });
      }

      this.clearOtp();
    },
     sanitizeText(text) {
      const translations = {
        "Invalid OTP": this.$t("invalid-otp"),
        "Too many OTP requests. Try again later.": this.$t("too-many-otp-requests-try-again-later"),
        "Maximum limit reached. Please request for a new OTP after one minute.": this.$t("maximum-limit-reached-please-request-for-a-new-otp-after-one-minute"),
        "Maximum verification attempts exceeded. Request a new OTP.": this.$t("maximum-verification-attempts-exceeded-request-a-new-otp")
      };

      return translations[text] || text;
    },

    closeModal() {
      this.clearOtp();
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.otp-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-container {
  position: relative;
  background: #f0f8ff;
  padding: 25px;
  border-radius: 10px;
  text-align: center;
  width: 350px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

h2 {
  color: #007bff;
  margin-bottom: 10px;
}

input {
  width: 90%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #007bff;
  border-radius: 5px;
  text-align: center;
  font-size: 18px;
}

.verify-btn {
  width: 90%;
  padding: 15px;
  margin-top: 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.verify-btn:hover {
  background: #0056b3;
}

.bottom-buttons {
  display: flex;
  justify-content: center; 
  margin-top: 15px;
}

.resend-btn,

.resend-btn {
  background: none;
  color: #007bff;
}


.cancel-btn:hover {
  background: rgb(7, 22, 233);
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  font-size: 30px;
  color: #ff0000;
  cursor: pointer;
}

.close-btn:hover {
  color: #0056b3;
}
</style>
<!-- BR#162 end -->
